import { Injectable } from '@angular/core';
import { Product } from '@shared/models/product.model';
import { TrackingTypeEnum } from '../models/tracking-type-enum';
import { ProductPropertiesEnum } from '@usf/product-types';
import { PRODUCT_ATTRIBUTE_TRACK } from '@usf/ngrx-product';
@Injectable({
  providedIn: 'root',
})
export class ProductsMapperService {
  static mapProducts = (products: Product[], trackType: TrackingTypeEnum) => {
    const res = [];
    products.forEach(product => {
      if (product.hasAlternative) {
        // original product
        res.push({
          divisionApn: `${product?.summary?.divisionNumber}-${product?.productNumber}`,
          attributes: product?.trackingAttributes,
          merchFeatureView: '1',
          merchFeatureName: trackType,
          exceptionView: '1',
          exceptionNumberOfSubs:
            product?.inventory?.substituteProducts?.length || 1,
        });
        //substitute product
        res.push({
          divisionApn: `${product?.summary?.divisionNumber}-${product?.alternative?.product?.productNumber}`,
          attributes: product?.alternative?.product?.trackingAttributes,
          merchFeatureView: '1',
          merchFeatureName: trackType,
          substitutionView: '1',
          substitutionParentApn: `${product?.summary?.divisionNumber}-${product?.productNumber}`,
        });
      } else {
        const isUnavailable: boolean =
          product?.inventory?.isDirect &&
          product?.inventory?.productStatus === '2';
        const isOutOfStockOrDiscontinued = product?.summary?.properties
          ? product?.summary?.properties.has(
              ProductPropertiesEnum.discontinued,
            ) ||
            product?.summary?.properties.has(ProductPropertiesEnum.outOfStock)
          : false;
        if (
          product?.hideOutOfStock ||
          (product?.summary?.availableToPromise &&
            product?.trackingAttributes?.includes(
              PRODUCT_ATTRIBUTE_TRACK.availableToPromise,
            ))
        ) {
          res.push({
            divisionApn: `${product?.summary?.divisionNumber}-${product?.productNumber}`,
            attributes: product?.trackingAttributes,
            merchFeatureView: '1',
            merchFeatureName: trackType,
            availabletoSellView: '1',
          });
        } else if (
          !product?.hasAlternative &&
          (isUnavailable || isOutOfStockOrDiscontinued)
        ) {
          res.push({
            divisionApn: `${product?.summary?.divisionNumber}-${product?.productNumber}`,
            attributes: product?.trackingAttributes,
            merchFeatureView: '1',
            merchFeatureName: trackType,
            exceptionView: '1',
            exceptionNumberOfSubs: '1',
          });
        } else {
          res.push({
            divisionApn: `${product?.summary?.divisionNumber}-${product?.productNumber}`,
            attributes: product?.trackingAttributes,
            merchFeatureView: '1',
            merchFeatureName: trackType,
          });
        }
      }
    });

    return res;
  };
}
